import gql from 'graphql-tag';

export class AttachmentFragments {
  static attachment = gql`
    fragment attachmentFragment on Attachment {
      type
      title
      description
      filename
      size
      published
      url
      library
      id
    }
  `;

  static accessRecipient = gql`
    fragment accessRecipientFragment on Recipient {
      id
      firstName
      lastName
      fullName
      roleName
    }
  `;

  static documentAttachment = gql`
    fragment documentAttachmentFragment on DocumentAttachment {
      id
      restrictAccess
      requireView
      previewUrl
      lastView
      lastUpload
      createdAt
      attachment {
        ...attachmentFragment
      }
      accessRecipientList {
        ...accessRecipientFragment
      }
    }
    ${AttachmentFragments.attachment}
    ${AttachmentFragments.accessRecipient}
  `;
}
